<template>
  <Card>
    <template #title> Component </template>
    <template #content>
      <Ghostbox :item-name="Survey.modelName.human({ count: 2 })" :link-options="linkOptions"/>
    </template>
  </Card>
</template>

<script setup>
import Survey from '@/models/Survey.js'
import Ghostbox from '@/components/Ghostbox.vue'
import { useI18nUtils } from '@/composables/utils/useI18nUtils.js'

const { t } = useI18nUtils()

let linkOptions = {
  name: 'home',
  text: t('general.item.new', { name: Survey.modelName.human() })
}
</script>
